<div class="grid-container full-height full v-pad" [ngClass]="{ 'margin-bottom-x-large': showExpediteMessage }">
	<ng-container *ngIf="page != null && indexLoaded; else loading">
		<div class="user-form-max-width">
			<ng-container [ngSwitch]="true">
				<ng-container *ngSwitchCase="displayMode === modes.Flow">
					<form [formGroup]="ngForm" #container>
						<h2 *ngIf="pageTitle != ''">{{pageTitle}}</h2>
						<ng-container *ngFor="let questionGroup of page.questions; let i = index">
							<div class="question-row">
								<div class="question-cell" *ngFor="let question of questionGroup; let j = index" [ngStyle]="{'flex-grow': question.flexGrow || 1}" [style.--error-min-height]="getMaxValidationCount(questionGroup) * 1.25 + 'rem'">
									<ng-template dynamic-component-loader [componentName]="question.type" [componentData]="question"
												 [componentContext]="workflow.context" [formGroup]="ngForm" [flowComponent]="this">
									</ng-template>
									<div class="error-container" *ngIf="ngForm.get(question.key).errors && ngForm.get(question.key).dirty || ngForm.get(question.key).touched">
										<span class="error" *ngFor="let error of getErrors(ngForm.get(question.key).errors)">{{error}}</span>
									</div>
								</div>
							</div>
						</ng-container>
						<div>
							<add-ad-hoc-reviewer [workOrderId]="workItemId" [workflow]="workflow" *ngIf="addAdhoc" (closeEvent)="toggleAdhoc($event)"></add-ad-hoc-reviewer>
						</div>
						<div class="form-button-group margin-top">
							<ng-container *ngFor="let button of page.specialButtons; let last=last">
								<button *ngIf="button?.visible()" class="button hollow" [ngClass]="{'minor-margin-right': !last}"
										(click)="buttonClick(button)" [disabled]="isButtonDisabled(button)">
									{{button.label}}
								</button>
							</ng-container>
						</div>
					</form>
					<ng-container *ngIf="showNavigationButtons">
						<ng-container *ngFor="let button of page.navigationButtons">
							<button *ngIf="showNextButton(button)" class="next-link vertical-middle" (click)="buttonClick(button)" [disabled]="disableNavigation || isButtonDisabled(button)">
								<span>{{button.label}}</span>
								<span class="next-link-span" aria-hidden="true">
									<svg-icon class="white" icon="icon-chevron-right"></svg-icon>
								</span>
							</button>
							<button *ngIf="showBackButton(button)" class="back-link vertical-middle" [disabled]="disableNavigation" (click)="buttonClick(button)">
								<span class="back-link-span" aria-hidden="true">
									<svg-icon class="white" icon="icon-chevron-left"></svg-icon>
								</span>
								<span>{{button.label}}</span>
							</button>
						</ng-container>
					</ng-container>
				</ng-container>
				<ng-container *ngSwitchCase="displayMode === modes.Eject">
					<div class="question-row">
						<div class="question-cell" style="flex-grow: 1">
							The summary shown below is a projection based upon the questions currently answered.  <br />
							While multiple fields may be showing missing, only those fields with clarification notes attached will be included in the letter summation.
						</div>
					</div>
					<div class="question-row">
						<div class="question-cell" [ngStyle]="{ 'flex-grow': ejectSummary.flexGrow || 1 }">
							<ng-template dynamic-component-loader [componentName]="ejectSummary.type" [componentData]="ejectSummary" [componentContext]="workflow.context"
										 [formGroup]="ngForm" [flowComponent]="this" (summaryLoaded)="onSummaryLoaded($event)">
							</ng-template>
						</div>
					</div>
					<div class="form-button-group margin-bottom">
						<button class="button hollow" (click)="generateLetter()" [disabled]="!ejectSummaryLoaded">Eject</button>
					</div>
				</ng-container>
				<ng-container *ngSwitchCase="displayMode === modes.GenerateLetter">
					<div class="question-row">
						<div class="question-cell" style="flex-grow: 1">
							<h2 class="no-margin">Create Communications</h2>
						</div>
					</div>
					<div class="question-row">
						<div class="question-cell">
							<text-loader [run]="loadingContent" [text]="'Generating Letter'" [tickType]="'.'" [interval]="1000"></text-loader>
							<text-editor *ngIf="!loadingContent && letterLoadError.length === 0" (formBuilt)="onTextFormBuilt($event)" [required]="true" [content]="letterContent"></text-editor>
							{{letterLoadError}}
						</div>
					</div>
					<div class="question-row">
						<div class="question-cell" style="flex-grow: 1;">
							<div class="bold full-width margin-top">Notes for clarification:</div>
							<clarification-notes *ngIf="!loadingContent" [instanceId]="workflow.id"></clarification-notes>
						</div>
					</div>
					<button class="back-link vertical-middle" (click)="reviewSummary()">
						<span class="back-link-span" aria-hidden="true">
							<svg-icon class="white" icon="icon-chevron-left"></svg-icon>
						</span>
						Summary
					</button>
					<button class="next-link vertical-middle" (click)="previewLetter()" [disabled]="ngForm.invalid">
						Preview Letter
						<span class="next-link-span" aria-hidden="true">
							<svg-icon class="white" icon="icon-chevron-right"></svg-icon>
						</span>
					</button>
				</ng-container>
				<ng-container *ngSwitchCase="displayMode === modes.PreviewLetter">
					<div class="question-row">
						<div class="question-cell" style="flex-grow: 1;">
							Please review the sample PDF for accuracy.  If the sample is satisfactory, click the 'Submit Letter for Mailing' button to send the letter to the mailing queue. <br />
							Otherwise, click 'Return to Preview' to adjust the contents of the letter.
						</div>
					</div>
					<div class="question-row">
						<div class="question-cell" style="flex-grow: 1;">
							<text-loader [run]="loadingPdf" [text]="'Generating PDF Preview'" [tickType]="'.'" [interval]="1000"></text-loader>
							<ngx-extended-pdf-viewer *ngIf="pdfUrl !== ''" [src]="pdfUrl" [textLayer]="false" [showAll]="true" [pageViewMode]="'infinite-scroll'"></ngx-extended-pdf-viewer>
						</div>
					</div>
					<button class="back-link vertical-middle" (click)="generateLetter()">
						<span class="back-link-span" aria-hidden="true">
							<svg-icon class="white" icon="icon-chevron-left"></svg-icon>
						</span>
						Return to Preview
					</button>
					<button class="next-link vertical-middle" (click)="submitLetter()" [disabled]="loadingPdf">
						Submit Letter for Mailing
						<span class="next-link-span" aria-hidden="true">
							<svg-icon class="white" icon="icon-chevron-right"></svg-icon>
						</span>
					</button>
				</ng-container>
			</ng-container>
		</div>
		<flow-sections [state]="state" [currentPage]="page" [isResuming]="returningUser && !isReviewForm" [sectionContext]="this.workflow.context.sections" [expediteSetting]="expediteSetting" [moduleConfig]="moduleConfig" [workflow]="workflow" (navigateSection)="navigateSection($event)"></flow-sections>
	</ng-container>
    <ng-container *ngIf="infiniteLoop">
        <div class="grid-x">
            <div class="cell large-12 bold red">
                {{infiniteLoopMessage}}
            </div>
        </div>
    </ng-container>
</div>
<a style="display: none;" #downloadLink></a>

<ng-template #loading>
    <div class="user-form-max-width">
        <text-loader [run]="!indexLoaded" [tickType]="'.'" [text]="'Loading Flow Content'" [interval]="2000"></text-loader>
    </div>
</ng-template>
